import React, { useEffect } from 'react';
import { getFramework, HOTKEY_TYPE, useIdentity } from '@/framework';
import { type GroupLayer } from '@/layers/group-layer';
import { IExportPlugin, PluginType } from '@/version-types';

const MakeupView: React.FC = React.memo(() => {
    const identity = useIdentity();

    // 实现快捷键逻辑
    useEffect(() => {
        const tryGetGroupLayer = () => {
            const groupLayer = framework.getInstance<GroupLayer>('GroupLayer');
            if (!groupLayer) {
                throw new Error('GroupLayer is not found');
            }
            return groupLayer;
        };
        const framework = getFramework(identity);
        const makeGroupHandle = framework.events.on(HOTKEY_TYPE.makeGroup, () => {
            const layerId = framework.operate.getActiveLayer()?.id;
            if (layerId) {
                tryGetGroupLayer().pack(layerId);
            }
        });
        const brokeGroupHandle = framework.events.on(HOTKEY_TYPE.brokeGroup, (e) => {
            const layerId = framework.operate.getActiveLayer()?.id;
            if (layerId) {
                tryGetGroupLayer().unpack(layerId);
            }
        });
        return () => {
            framework.events.off(makeGroupHandle);
            framework.events.off(brokeGroupHandle);
        };
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'hotkey-event-makeup',
    render() {
        return <MakeupView />;
    },
};

export default exportPlugin;
